import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import LoadingSpinner from "components/LoadingSpinner";
import AskChuffedButton from "components/AskChuffedButton";

import "./_style.scss";

const InfoBox = ({
  children, heading, isLoading, includeSupport,
}) => (
  <div
    className={
        classNames(
          "info-box",
          {
            "--loading": isLoading,
          },
        )
      }
  >
    <div className="info-box__heading">
      <span className="info-box__heading-text">💡 Hi, I'm Tippy</span>
    </div>
    {isLoading
      ? (
        <div style={{ marginTop: "1.5rem", textAlign: "center" }}>
          <LoadingSpinner />
        </div>
      )
      : (
        <div className="info-box__body">
          <h2 className="info-box__content-heading">
            {heading}
          </h2>
          <div className="info-box__content">
            <div className="info-box__text">
              {children}
            </div>
            {includeSupport && (
            <div className="info-box__content">
              <div className="info-box__text">
                <strong>Need more help?</strong>
                <AskChuffedButton>Ask Chuffed</AskChuffedButton>
              </div>
            </div>
            )}
          </div>
        </div>
      )}
  </div>
);

InfoBox.defaultProps = {
  includeSupport: false,
};

InfoBox.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
  isLoading: PropTypes.bool,
  includeSupport: PropTypes.bool,
};

export default InfoBox;
